;(function () {
  angular
    .module('app')
    .factory('excludeLinksInterceptor', [
      '$q',
      'SKIP_HATEOAS_LINK',
      'TS_BASE_URL',
      excludeLinksInterceptor
    ])

  function excludeLinksInterceptor($q, SKIP_HATEOAS_LINK, TS_BASE_URL) {
    return {
      request: function (config) {
        if (config.url.startsWith(TS_BASE_URL)) {
          config.params = config.params || {}

          if (config.params.expand) {
            if (config.params.expand.indexOf(SKIP_HATEOAS_LINK) < 0) {
              config.params.expand =
                config.params.expand + ',' + SKIP_HATEOAS_LINK
            }
          } else {
            config.params.expand = SKIP_HATEOAS_LINK
          }
        }

        return config || $q.when(config)
      }
    }
  }
})()
